module.exports = __webpack_public_path__ + "assets/adpoly-facility-sport-facilities-bulk-upload-template.2062a2ec.xlsx";